import $ from 'jquery';
import debug from "debug";

import "./plugins";
import "./components";
import "./vendor";

const log = debug('fusion-core');

$(()=>{
	log('ready');
});



// WEBPACK FOOTER //
// ./project/client/src/core/index.js